<template>
  <v-dialog v-model="dialog" width="600px" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text"
        ><v-toolbar-title class="text-uppercase">Thêm học phần mới</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="dialog = false">close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-divider></v-divider>
        <CreateGradeForm ref="form" :editCode="true" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn class="text-none text-uppercase" outlined @click="dialog = false">Huỷ</v-btn>
        <v-btn color="primary text-none text-uppercase" elevation="0" :loading="loading" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CreateGradeForm from '@/components/basic/form/CreateGradeForm.vue'
import { mapActions } from 'vuex'
export default {
  components: {
    CreateGradeForm,
  },
  props: {
    state: Boolean,
  },
  data() {
    return {
      dialog: false,
      loading: false,
    }
  },
  methods: {
    ...mapActions('grade', ['createGrade']),
    ...mapActions({
      fetchGrades: 'grade/fetchGrades',
    }),
    async save() {
      if (!this.$refs.form.validate()) return
      try {
        this.loading = true
        const data = this.$refs.form.getData()
        await this.createGrade({ ...data })
        await this.fetchGrades({ _sort: 'createdAt:desc' })
        this.$alert.addSuccess()
        this.$refs.form.reset()
        this.dialog = false
      } catch (error) {
        this.$alert.addError()
      } finally {
        this.loading = false
      }
    },
  },
  watch: {
    state() {
      this.dialog = true
    },
  },
}
</script>
